import MousePosition from 'ol/control/MousePosition';
import { MAP_TIME, MAP_TIME_ACTIVE } from '../time/time';
import { CLASS_CONTROL, CLASS_UNSELECTABLE } from 'ol/css';

import EventType from 'ol/events/EventType';
import Control from 'ol/control/Control';

import { faHistory, faX } from '@fortawesome/pro-solid-svg-icons';
import { faClock } from '@fortawesome/pro-light-svg-icons';

import { icon } from '@fortawesome/fontawesome-svg-core'

import { formatDateTime } from '../../i18n/format';

import './time_position.css';

class TimePosition extends Control {

	constructor(opt_options) {
		const options = opt_options ? opt_options : {};
		super({
				element: document.createElement('div'),
				render: options.render,
				target: options.target
		});

		const className = options.className !== undefined ? options.className : 'ol-time-position';
		const containerElement = this.element;

		containerElement.className = `${className} ${CLASS_UNSELECTABLE} ${CLASS_CONTROL}`;

		this.textElement = document.createElement("span");
		this.htmlIcon = icon(faHistory).html[0]

		const createButton = (styleName, buttonIcon) => {
			const buttonElement = document.createElement('button');
			buttonElement.setAttribute('type', 'button');
			buttonElement.className = `${className}-${styleName} ${CLASS_UNSELECTABLE}`;

			const iconNode = icon(buttonIcon).node[0]
			buttonElement.appendChild( iconNode );

			buttonElement.style.display = 'none';
			return buttonElement;
		}

		const activateButton = createButton("activate-time-slider", faClock)
		const deactivateButton = createButton("deactivate-time-slider", faX)

		this.element.appendChild( activateButton );
		this.element.appendChild( this.textElement );
		this.element.appendChild( deactivateButton);

		this.activateButton = activateButton;
		this.deactivateButton = deactivateButton;

		activateButton.addEventListener(EventType.CLICK, this.handleClick.bind(this), false);
		deactivateButton.addEventListener(EventType.CLICK, this.handleClick.bind(this), false);

		this.element.style.display = "none";
	}

	setMap(map) {
		super.setMap(map);

		if( map ) {
			// TODO unlisten
   			map.on('propertychange', ({key}) => {
   				if( key === MAP_TIME_ACTIVE || key === MAP_TIME ) {
					this.updateControl();
   				}
   			});
		}
	}

	handleClick() {
		const map = this.getMap();

		const active = map.get(MAP_TIME_ACTIVE);
		map.set(MAP_TIME_ACTIVE, !active);
	}

	updateControl() {
		const map = this.getMap();
		if( map ) {
			const time = map.get(MAP_TIME);
			const timeActive = map.get(MAP_TIME_ACTIVE)

			const element = this.textElement;
			const displayTime = timeActive && time;

			this.activateButton.style.display = displayTime ? "none" : "";
			this.deactivateButton.style.display = displayTime ? "" : "none";

			element.style.display = displayTime ? "" : "none";

			if( time ) {
				element.innerHTML = this.htmlIcon + " "  + formatDateTime(time);
			} else {
				element.innerHTML = "";
			}

			if( !time && !displayTime ) {
				this.element.style.display = "none";
			} else {
				this.element.style.display = "";
			}
		}
	}
}

const timePosition = (target) => {
	return new TimePosition({
        target: target,
    });
}

export {
	timePosition
}